<div *ngIf="loading" class="display-flex w-100 loading-container">
    <i class="fa fa-spinner fa-spin"></i>
    <h3 class="mt-2">Loading application...</h3>
</div>
@if (hasLoadingError) {
    <div class="display-flex w-100 loading-container">
        <h4 class="my-2">Either an error has occurred, or the requested application was not found.</h4>
        <span>Please try refreshing, or <a routerLink="/app/clients">search for the client record and try again.</a></span>
    </div>
}
<div class="container" *ngIf="!loading && !hasLoadingError">
    <div class="row">
        <div class="status-container">
        <h2 class="page-title">Edit {{administrativeFundName}} Application</h2>
        <div *ngIf="!!assistanceApplication" class="status-section">
            <div class="display-flex flex-row audit-status-text" [class.pointer]="canAudit()" (click)="canAudit() ? showAuditStateModal() : null">
                <i class="fa fa-pencil-square-o"></i>
                <strong>{{ getAuditStateLabel() }}</strong>
            </div>
            <div *ngIf="shouldShowRegularAuditSection()">
                <app-assistance-application-basic-audit
                        [assistanceApplicationId]="applicationId"
                        [assistanceApplication]="assistanceApplication"
                        [user]="user"
                        (submitReadyForReview)="setReadyForReview()"
                ></app-assistance-application-basic-audit>
            </div>
            <div *ngIf="shouldShowAgencyAuditSection()">
                <app-assistance-application-agency-audit
                        [assistanceApplicationId]="applicationId"
                        [assistanceApplication]="assistanceApplication"
                        [user]="user"
                        (submitReadyForReview)="setReadyForReview()"
                ></app-assistance-application-agency-audit>
            </div>
            <div class="status-actions">
                <button *ngIf="showSaveButton"
                        [disabled]="(assistanceApplicationForm?.loading$ | async)"
                        class="hidden-print btn btn-outline-primary mt-2 w-100"
                        [tooltip]="'Save all changes without changing the application status.'"
                        [delay]="1000"
                        (click)="submit()">
                    <i class="fa fa-save me-1"></i>
                    Save Application
                </button>
                <button *ngIf="canResubmit"
                        [disabled]="(assistanceApplicationForm?.loading$ | async)"
                        class="hidden-print btn btn-outline-warning mt-2 w-100"
                        [tooltip]="'Save all changes and resubmit the denied application for review.'"
                        [delay]="1000"
                        (click)="resubmit()">
                    <i class="fa fa-refresh me-1"></i>
                    Save & Resubmit
                </button>
            </div>
        </div>
        </div>
    </div>
    <section class="widget">
        <div class="widget-body">
            <div class="mt">
                <div *ngIf="!loading">
                    <app-assistance-application-form
                            [client]="assistanceApplication?.client"
                            [user]="assistanceApplication?.createdByUser"
                            [assistanceApplication]="assistanceApplication"
                            [auditState]="auditState"
                            [applicationLoading]="loading"
                            [defaultOpenDocumentUpload]="false"
                            [isNewApplication]="false"
                            (onUpdate)="onUpdate($event)"
                            [hasTranslation]="hasTranslation"
                            [canUploadDocuments]="canUploadDocuments"
                            [formValuesSet]="formValuesSet"
                            #fs
                    ></app-assistance-application-form>
                </div>
                <button *ngIf="showSaveButton"
                        [disabled]="(assistanceApplicationForm?.loading$ | async)"
                        class="hidden-print btn btn-primary save-case"
                        tooltip="Save all changes without changing the application status."
                        (click)="submit()">
                    <i class="fa fa-save me-1"></i>
                    Save Application
                </button>
                <br>
                &nbsp;<hr>
                <br>
                <button class="hidden-print btn btn-primary print-case" (click)="printCase()">
                    <i class="fa fa-print me-1"></i>
                    Print Application</button>
                <app-assistance-application-tabs *ngIf="assistanceApplication" class="hidden-print"
                                                 [assistanceApplication]="assistanceApplication"
                                                 #tabs></app-assistance-application-tabs>
                <hr>
                <app-activity-audit-tabs *ngIf="assistanceApplication" class="hidden-print"
                                         [assistanceApplication]="assistanceApplication"
                                         [canAudit]="canAudit()"
                                         new
                                         #auditTabs></app-activity-audit-tabs>
            </div>
        </div>
    </section>
</div>
<prompt-dialog #auditModal
               [size]="'lg'"
               [titleText]="'Assistance Application Audit Status'"
               [showTitle]="true"
               [overrideFooter]="true">
    <div body>
        <app-manage-audit-state
                [assistanceApplicationId]="applicationId"
                (savedAuditState)="savedAudit = $event"
                (closeModal)="onClickCancelAuditState()"
        ></app-manage-audit-state>
    </div>

    <div footer></div>
</prompt-dialog>
